import { jwtVerify, importSPKI } from 'jose'
export default async function verify_jwt({ token, publicKey }) {
  try {
    // Chuyển đổi khóa PEM sang CryptoKey -> Thì mới dùng được verify của jose
    const rsaPublicKey = await importSPKI(publicKey, 'RS256')

    const { payload } = await jwtVerify(token, rsaPublicKey)

    return { email: payload.email, groups: payload.groups, uuid: payload.sub }
  } catch (error) {
    return false
  }
}
